<template>
  <!-- Menu Lateral Desktop -->
  <nav class="navbar-v2">
    <div class="navbar-scroll">
      <ul class="nav-menu">    

        <!-- Página Inicial -->
        <li :class="{ 'active': $route.path === '/admin' }">
          <router-link class="nav-item" to="/admin">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'home']" />
            </div>
            <span class="nav-text">Página Inicial</span>
          </router-link>
        </li>

        <!-- Contratos -->
        <li v-if="$store.getters.user?.access?.indexOf(2) > -1" 
            :class="{ 'active': $route.path === '/admin/contract-list' }">
          <router-link class="nav-item" to="/admin/contract-list">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'file-contract']" />
            </div>
            <span class="nav-text">Contratos</span>
          </router-link>
        </li>

        <!-- Financeiro -->
        <li v-if="$store.getters.user?.access?.indexOf(3) > -1" 
            :class="{ 'active': isFinanceiroActive }"
            class="has-submenu">
          <a class="nav-item submenu-trigger" @click="toggleSubmenu('financeiro')">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'coins']" />
            </div>
            <span class="nav-text">Financeiro</span>
            <font-awesome-icon 
              :icon="['fa', submenus.financeiro ? 'chevron-down' : 'chevron-right']" 
              class="submenu-arrow" 
            />
          </a>
          <ul class="submenu" :class="{ 'submenu-open': submenus.financeiro }">
            <li v-if="$store.getters.user?.access?.indexOf(4) > -1">
              <router-link to="/admin/invoice-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Consulta de Títulos</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(5) > -1">
              <router-link to="/admin/financial-dash" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Dashboard Financeiro</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Pedidos -->
        <li v-if="$store.getters.user?.access?.indexOf(9) > -1" 
            :class="{ 'active': isPedidosActive }"
            class="has-submenu">
          <a class="nav-item submenu-trigger" @click="toggleSubmenu('pedidos')">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'shopping-cart']" />
            </div>
            <span class="nav-text">Pedidos</span>
            <font-awesome-icon 
              :icon="['fa', submenus.pedidos ? 'chevron-down' : 'chevron-right']" 
              class="submenu-arrow" 
            />
          </a>
          <ul class="submenu" :class="{ 'submenu-open': submenus.pedidos }">
            <li v-if="$store.getters.user?.access?.indexOf(10) > -1">
              <router-link to="/admin/order-new" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Novo Pedido</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(11) > -1">
              <router-link to="/admin/order-unbilled-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos a Faturar</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(12) > -1">
              <router-link to="/admin/order-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos em Rota</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(13) > -1">
              <router-link to="/admin/order-finished-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos Entregues</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(14) > -1">
              <router-link to="/admin/order-list-ni" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos Realizados</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(15) > -1">
              <router-link to="/admin/order-draft" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos em Rascunho</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Embalagens -->
        <li v-if="dotEnv.isAmbientaly && $store.getters.user?.access?.indexOf(19) > -1" 
            :class="{ 'active': $route.path === '/admin/packaging-list' }">
          <router-link class="nav-item" to="/admin/packaging-list">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'box-open']" />
            </div>
            <span class="nav-text">Embalagens</span>
          </router-link>
        </li>

        <!-- Documentos -->
        <li v-if="$store.getters.user?.access?.indexOf(20) > -1" 
            :class="{ 'active': isDocumentosActive }"
            class="has-submenu">
          <a class="nav-item submenu-trigger" @click="toggleSubmenu('documentos')">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'file-alt']" />
            </div>
            <span class="nav-text">Documentos</span>
            <font-awesome-icon 
              :icon="['fa', submenus.documentos ? 'chevron-down' : 'chevron-right']" 
              class="submenu-arrow" 
            />
          </a>
          <ul class="submenu" :class="{ 'submenu-open': submenus.documentos }">
            <li v-if="$store.getters.user?.access?.indexOf(21) > -1">
              <router-link to="/admin/fds-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>FDS</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(22) > -1">
              <router-link to="/admin/fde-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Ficha de Emergência</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(29) > -1">
              <router-link to="/admin/winner-docs" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Certidões</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Telemetria -->
        <li v-if="$store.getters.user?.access?.indexOf(40) > -1" 
            :class="{ 'active': $route.path === '/admin/telemetry' }"
            class="menu-item-novo">
          <router-link class="nav-item" to="/admin/telemetry">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'broadcast-tower']" />
            </div>
            <span class="nav-text">Telemetria</span>
            <span class="novo-badge">Novo</span>
          </router-link>
        </li>

        <!-- Administrativo -->
        <li v-if="$store.getters.user?.access?.indexOf(23) > -1" 
            :class="{ 'active': isAdministrativoActive }"
            class="has-submenu">
          <a class="nav-item submenu-trigger" @click="toggleSubmenu('administrativo')">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'cogs']" />
            </div>
            <span class="nav-text">Administrativo</span>
            <font-awesome-icon 
              :icon="['fa', submenus.administrativo ? 'chevron-down' : 'chevron-right']" 
              class="submenu-arrow" 
            />
          </a>
          <ul class="submenu" :class="{ 'submenu-open': submenus.administrativo }">
            <li v-if="$store.getters.user?.access?.indexOf(24) > -1">
              <router-link to="/admin/user-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Usuários</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(25) > -1">
              <router-link to="/admin/timelogs" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Tempo de Logs</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(26) > -1">
              <router-link to="/admin/logaccess" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Log de Acesso</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(27) > -1">
              <router-link to="/admin/configs" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Configurações</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user?.access?.indexOf(28) > -1">
              <router-link to="/admin/reports" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Relatórios</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Meu Perfil (para usuários sem acesso administrativo) -->
        <li v-else :class="{ 'active': $route.path === '/admin/profile' }">
          <router-link class="nav-item" to="/admin/profile">
            <div class="nav-icon">
              <font-awesome-icon :icon="['fa', 'user']" />
            </div>
            <span class="nav-text">Meu Perfil</span>
          </router-link>
        </li>
      </ul>

      <!-- Footer do menu -->
      <div class="navbar-footer">
        <div class="footer-content">
          <div class="company-info">
            <h4 class="text-center">{{ applicationName }}</h4>
            <p class="text-center">© 2023 Todos os direitos reservados</p>
          </div>
          <div class="developer-info">
            <p style="text-align: justify;">Desenvolvido por <a href="https://innovareti.com.br" target="_blank">InnovareTI</a></p>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- Overlay para mobile -->
  <div class="mobile-overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu"></div>

  <!-- Menu Mobile -->
  <div class="mobile-menu" :class="{ 'active': isMobileMenuOpen }">
    <div class="mobile-header">
      <div class="mobile-header-content">
        <router-link to="/" class="mobile-brand" @click="closeMobileMenu">
          <img src="../../assets/images/favicon.png" alt="Logo" />
          <span class="brand-text">BAUMINAS</span>
        </router-link>
        <button class="close-btn" @click="closeMobileMenu">
          <font-awesome-icon :icon="['fa', 'times']" />
        </button>
      </div>
      <div class="mobile-user-info" v-if="$store.getters.user">
        <div class="user-avatar">
          <img :src="$store.getters.user.photo" alt="Avatar" />
        </div>
        <div class="user-details">
          <span class="user-name">{{ $store.getters.user.name }}</span>
          <span class="company-name">{{ $store.getters.user.customer_name }}</span>
        </div>
      </div>
    </div>

    <div class="mobile-content">
      <nav class="mobile-nav">
        <ul class="mobile-nav-list">
          <!-- Itens de menu mobile -->
          <li :class="{ 'active': $route.path === '/admin' }">
            <router-link to="/admin" class="mobile-nav-link" @click="closeMobileMenu">
              <div class="mobile-nav-icon">
                <font-awesome-icon :icon="['fa', 'home']" />
              </div>
              <span class="mobile-nav-label">Página Inicial</span>
            </router-link>
          </li>

          <li v-if="$store.getters.user?.access?.indexOf(2) > -1"
              :class="{ 'active': $route.path === '/admin/contract-list' }">
            <router-link to="/admin/contract-list" class="mobile-nav-link" @click="closeMobileMenu">
              <div class="mobile-nav-icon">
                <font-awesome-icon :icon="['fa', 'file-contract']" />
              </div>
              <span class="mobile-nav-label">Contratos</span>
            </router-link>
          </li>

          <!-- Submenu Financeiro Mobile -->
          <li v-if="$store.getters.user?.access?.indexOf(3) > -1" class="has-mobile-submenu">
            <a @click="toggleMobileSubmenu('financeiro')" class="mobile-nav-link submenu-toggle">
              <div class="mobile-nav-icon">
                <font-awesome-icon :icon="['fa', 'coins']" />
              </div>
              <span class="mobile-nav-label">Financeiro</span>
              <div class="mobile-submenu-arrow">
                <font-awesome-icon :icon="['fa', mobileSubmenus.financeiro ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="mobile-submenu">
              <ul v-if="mobileSubmenus.financeiro" class="mobile-submenu">
                <li v-if="$store.getters.user?.access?.indexOf(4) > -1">
                  <router-link to="/admin/invoice-list" @click="closeMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Consulta de Títulos</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user?.access?.indexOf(5) > -1">
                  <router-link to="/admin/financial-dash" @click="closeMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Dashboard Financeiro</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </li>

          <!-- Adicionar outros submenus mobile conforme necessário -->
          
          <!-- Trocar Empresa -->
          <li class="has-mobile-submenu">
            <a @click="toggleMobileSubmenu('trocarEmpresa')" class="mobile-nav-link submenu-toggle">
              <div class="mobile-nav-icon">
                <font-awesome-icon :icon="['fa', 'building']" />
              </div>
              <span class="mobile-nav-label">Trocar Empresa</span>
              <div class="mobile-submenu-arrow">
                <font-awesome-icon :icon="['fa', mobileSubmenus.trocarEmpresa ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="mobile-submenu">
              <ul v-if="mobileSubmenus.trocarEmpresa" class="mobile-submenu">
                <li v-for="(userCompany, index) in $store.getters.userCompanies" :key="index">
                  <a @click="changeCompany(userCompany); closeMobileMenu()">
                    <span class="submenu-bullet"></span>
                    <span>{{ userCompany.customer.name }}</span>
                  </a>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import env from "../../env.js";

export default {
  name: 'Navbarv2',
  props: {
    isMobileMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dotEnv: {
        isAmbientaly: false,
      },
      applicationName: env.applicationName,
      submenus: {
        financeiro: false,
        pedidos: false,
        documentos: false,
        administrativo: false,
      },
      mobileSubmenus: {
        financeiro: false,
        pedidos: false,
        documentos: false,
        administrativo: false,
        trocarEmpresa: false,
      }
    };
  },
  computed: {
    isFinanceiroActive() {
      return ['/admin/invoice-list', '/admin/financial-dash'].includes(this.$route.path);
    },
    isPedidosActive() {
      return [
        '/admin/order-unbilled-list',
        '/admin/order-list', 
        '/admin/order-new',
        '/admin/order-finished-list', 
        '/admin/order-draft',
        '/admin/order-list-ni'
      ].includes(this.$route.path);
    },
    isDocumentosActive() {
      return ['/admin/fds-list', '/admin/fde-list', '/admin/winner-docs'].includes(this.$route.path);
    },
    isAdministrativoActive() {
      return [
        '/admin/user-list', 
        '/admin/timelogs',
        '/admin/customer-list', 
        '/admin/logaccess',
        '/admin/configs', 
        '/admin/reports'
      ].includes(this.$route.path);
    }
  },
  watch: {
    '$route'(to) {
      // Abrir submenu automaticamente se a rota estiver ativa
      if (this.isFinanceiroActive) this.submenus.financeiro = true;
      if (this.isPedidosActive) this.submenus.pedidos = true;
      if (this.isDocumentosActive) this.submenus.documentos = true;
      if (this.isAdministrativoActive) this.submenus.administrativo = true;
    }
  },
  created() {
    this.dotEnv.isAmbientaly = env.isAmbientaly;
    
    // Abrir submenu se a rota atual estiver ativa
    if (this.isFinanceiroActive) this.submenus.financeiro = true;
    if (this.isPedidosActive) this.submenus.pedidos = true;
    if (this.isDocumentosActive) this.submenus.documentos = true;
    if (this.isAdministrativoActive) this.submenus.administrativo = true;
  },
  methods: {
    toggleSubmenu(menu) {
      // Fechar outros submenus
      Object.keys(this.submenus).forEach(key => {
        if (key !== menu) {
          this.submenus[key] = false;
        }
      });
      
      // Alternar submenu atual
      this.submenus[menu] = !this.submenus[menu];
    },
    
    toggleMobileSubmenu(menu) {
      this.mobileSubmenus[menu] = !this.mobileSubmenus[menu];
    },
    
    closeMobileMenu() {
      this.$emit('toggle-mobile-menu');
    },
    
    async changeCompany(userCompany) {
      await this.$store.dispatch('changeUserCompany', userCompany);
    }
  }
};
</script>

<style scoped>
/* ================================
   VARIÁVEIS CSS
================================= */
:root {
  --primary-color: #3b82f6;
  --primary-dark: #2563eb;
  --secondary-color: #64748b;
  --accent-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --success-color: #22c55e;
  --dark-color: #1e293b;
  --light-color: #f8fafc;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --border-radius: 8px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ================================
   NAVBAR PRINCIPAL
================================= */
.navbar-v2 {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-right: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg);
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  width: 260px;
  z-index: 900;
  overflow: hidden;
}

.navbar-scroll {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.navbar-scroll::-webkit-scrollbar {
  width: 6px;
}

.navbar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.navbar-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

.navbar-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}

/* ================================
   MENU PRINCIPAL
================================= */
.nav-menu {
  list-style: none;
  padding: 16px 0;
  margin: 0;
}

.nav-label {
  padding: 0 20px 8px 20px;
  margin: 0 0 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.nav-label-text {
  font-size: 11px;
  font-weight: 700;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin: 2px 10px;
  border-radius: var(--border-radius);
  color: var(--dark-color) !important;
  text-decoration: none;
  transition: var(--transition);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  border: none;
  background: transparent;
  width: calc(100% - 20px);
}

.nav-item:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%);
  transform: translateX(4px);
  color: var(--primary-color) !important;
}

/* Garantir que router-link herdem as cores corretamente */
router-link.nav-item {
  color: var(--dark-color) !important;
}

router-link.nav-item:hover {
  color: var(--primary-color) !important;
}

/* Força para todos os links dentro do menu */
.nav-menu a {
  color: var(--dark-color) !important;
}

.nav-menu a:hover {
  color: var(--primary-color) !important;
}

.nav-menu li.active a {
  color: var(--primary-color) !important;
}

.nav-menu li.active a:hover {
  color: var(--primary-color) !important;
}

.nav-menu li.active .nav-item {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: white !important;
  box-shadow: var(--shadow-md);
}

.nav-menu li.active .nav-item:hover {
  transform: translateX(2px);
  box-shadow: var(--shadow-lg);
  color: var(--primary-color) !important;
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.nav-text {
  flex: 1;
  font-weight: 500;
  color: inherit;
}

/* Garantir que todos os ícones herdem a cor do item pai */
.nav-icon {
  color: inherit;
}

.nav-icon svg {
  color: inherit;
}

.submenu-arrow {
  margin-left: auto;
  transition: var(--transition);
  font-size: 12px;
}

.novo-badge {
  background: linear-gradient(135deg, var(--danger-color) 0%, #ff6b6b 100%);
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  margin-left: auto;
  animation: glow 2s ease-in-out infinite alternate;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

@keyframes glow {
  from { box-shadow: 0 0 5px rgba(239, 68, 68, 0.5); }
  to { box-shadow: 0 0 15px rgba(239, 68, 68, 0.8); }
}

/* ================================
   SUBMENUS
================================= */
.submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: var(--transition);
  background: rgba(248, 250, 252, 0.8);
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  margin: 0 10px 6px 10px;
}

.submenu-open {
  max-height: 500px;
  opacity: 1;
  padding: 8px 0;
}

.submenu-item {
  display: flex;
  align-items: center;
  padding: 10px 20px 10px 40px;
  color: var(--secondary-color);
  text-decoration: none;
  transition: var(--transition);
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  margin: 2px 8px;
}

.submenu-item:hover {
  background: rgba(59, 130, 246, 0.1);
  color: var(--primary-color);
  transform: translateX(4px);
}

.submenu-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--secondary-color);
  margin-right: 12px;
  transition: var(--transition);
}

.submenu-item:hover .submenu-dot {
  background: var(--primary-color);
  transform: scale(1.2);
}

/* ================================
   FOOTER DO NAVBAR
================================= */
.navbar-footer {
  padding: 16px;
  border-top: 1px solid var(--border-color);
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.9) 0%, rgba(241, 245, 249, 0.9) 100%);
  margin-top: auto;
}

.footer-content {
  text-align: center;
}

.company-info h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--dark-color);
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.company-info p,
.developer-info p {
  margin: 4px 0;
  font-size: 11px;
  color: var(--secondary-color);
}

.developer-info a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  transition: var(--transition);
}

.developer-info a:hover {
  color: var(--accent-color);
}

/* ================================
   MOBILE MENU
================================= */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1998;
  opacity: 0;
  visibility: hidden;
  transition: var(--transition);
  backdrop-filter: blur(5px);
}

.mobile-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 320px;
  height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  z-index: 1999;
  transition: var(--transition);
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--border-color);
  overflow-y: auto;
}

.mobile-menu.active {
  right: 0;
  visibility: visible;
}

.mobile-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.mobile-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: white;
}

.mobile-brand img {
  width: 32px;
  height: 32px;
  border-radius: 6px;
}

.brand-text {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.mobile-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.user-avatar img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  display: block;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-name {
  display: block;
  font-size: 12px;
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

.mobile-nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav-list li {
  margin: 4px 12px;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  color: var(--dark-color);
  text-decoration: none;
  border-radius: var(--border-radius);
  transition: var(--transition);
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
}

.mobile-nav-link:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%);
  color: var(--primary-color);
  transform: translateX(4px);
}

.mobile-nav-list li.active .mobile-nav-link {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: var(--primary-color);
  box-shadow: var(--shadow-md);
}

.mobile-nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.mobile-nav-label {
  flex: 1;
  font-size: 14px;
}

.mobile-submenu-arrow {
  margin-left: auto;
  font-size: 12px;
  transition: var(--transition);
}

.mobile-submenu {
  list-style: none;
  padding: 8px 0;
  margin: 8px 0 0 0;
  background: rgba(248, 250, 252, 0.8);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}

.mobile-submenu li a {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  color: var(--secondary-color);
  text-decoration: none;
  transition: var(--transition);
  font-size: 13px;
  margin: 2px 8px;
  border-radius: 6px;
  cursor: pointer;
}

.mobile-submenu li a:hover {
  background: rgba(59, 130, 246, 0.1);
  color: var(--primary-color);
  transform: translateX(4px);
}

.submenu-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--secondary-color);
  margin-right: 12px;
  transition: var(--transition);
}

.mobile-submenu li a:hover .submenu-bullet {
  background: var(--primary-color);
  transform: scale(1.2);
}

/* Animações para submenus mobile */
.mobile-submenu-enter-active,
.mobile-submenu-leave-active {
  transition: all 0.3s ease;
}

.mobile-submenu-enter-from,
.mobile-submenu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ================================
   RESPONSIVIDADE
================================= */
@media (max-width: 1024px) {
  .navbar-v2 {
    display: none;
  }
}

@media (max-width: 768px) {
  .mobile-menu {
    width: 85%;
    right: -85%;
  }
  
  .mobile-overlay.active {
    opacity: 1;
    visibility: visible;
    z-index: 998;
  }
}

@media (max-width: 480px) {
  .mobile-header {
    padding: 16px;
  }

  .mobile-user-info {
    padding: 12px;
  }

  .user-name {
    font-size: 13px;
  }

  .company-name {
    font-size: 11px;
  }
}
</style> 